import Vue from 'vue'
import {Module} from 'vuex'
import {RootState} from '@/store/types'
import mutations from '@/modules/widget/store/mutations'
import actions from '@/modules/widget/store/actions'
import Widget from '@/modules/widget/model/Widget'
import getters from '@/modules/widget/store/getters'
import WidgetType from '@/modules/widget/model/WidgetType'

/**
 * Define el estado del módulo de Widgets
 */
export interface WidgetState {
    /**
     * Disposición de los widgets actualmente mostrada al usuario
     */
    layout: Widget[],

    /**
     * Indica si el catalogo de widget se encuentra activo
     */
    widgetCatalog: boolean,

    /**
     * Registra los tipos de widgets disponibles para añadir desde el catalogo
     */
    widgetTypes: WidgetType[],
}

const module: Module<WidgetState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    getters,
    state: {
        layout: [],
        widgetCatalog: false,
        widgetTypes: [
            {
                name: 'Clock',
                component: 'ClockWidget',
                resizable: false,
                minimumColumnWidth: 2,
                minimumColumnHeight: 3,
                maxQuantity: 1,
                title: 'Reloj',
                description: 'Reloj analógico que muestra la hora del sistema',
                previewImage: '/widget-previews/clock-widget-preview.PNG',
            },
            {
                name: 'Weather',
                component: 'WeatherWidget',
                resizable: true,
                minimumColumnHeight: 1,
                minimumColumnWidth: 1,
                maxQuantity: 4,
                title: 'Tiempo meteorológico',
                description: 'Muestra la temperatura y tiempo de la zona',
                previewImage: '/widget-previews/weather-widget-preview.PNG',
            },
            {
                name: 'UserRegistrationStats',
                component: 'UserRegistrationStatsWidget',
                resizable: true,
                minimumColumnWidth: 3,
                minimumColumnHeight: 3,
                maxQuantity: 1,
                title: 'Estadísticas de registro de usuarios',
                description: 'Muestra una gráfica con la evolución de registros de usuarios',
                previewImage: '/widget-previews/user-registration-stats-widget-preview.PNG',
            },
        ],
    },
}

export default module
